import Vue from 'vue'
import Vuetify from 'vuetify'
import fr from 'vuetify/es5/locale/fr';
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css'

import '../style/main.css'

Vue.use(Vuetify)
const opts = {
    theme: {
        dark: false,
        themes: {
            light: {
                primary: '#20D489',
                indigo: '#5710b2',
                secondary: '#00B2FF',
                red: '#ee6858',
                error: '#ee6858',
                success: '#20D489',
                orange: '#f5b849',
            }
        },
    },
    lang: {
        locales: {fr},
        current: 'fr',
    },
    icons: {
        iconfont: 'mdi',
    },
}
export default new Vuetify(opts)
